exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* BADGES */\r\n.badge {\r\n    font-weight: normal;\r\n    background: #ffffff;\r\n    color: #6a7a84;\r\n}\r\n\r\n.badge.badge-default {\r\n    background: #acb7bf;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-primary {\r\n    background: #0190fe;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-secondary {\r\n    background: #6a7a84;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-success {\r\n    background: #46be8a;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-info {\r\n    background: #0887c9;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-danger {\r\n    background: #fb434a;\r\n    color: #ffffff;\r\n}\r\n\r\n.badge.badge-warning {\r\n    background: #f39834;\r\n    color: #ffffff;\r\n}\r\n\r\n.btn .badge {\r\n    top: 1px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/assets/modules/vendors/bootstrap/css/badge.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/index.js?{"ident":"postcss"}!./src/assets/modules/vendors/bootstrap/css/badge.css
// module chunks = 3